export const informations = {
    gender: {
        label: "Sexe",
        man: "homme",
        woman: "femme",
        other: "autre"
    },
    'main-title': "Informations générales",
    title: {
        label: "Titre",
        placeholder: "ex : Ostéopathe D.O.",
        title: "Veuillez renseigner votre titre"
    },
    'last-name': {
        label: "Nom",
        'error-msg': "Merci de renseigner votre nom",
        placeholder: "ex : Still",
        title: "Veuillez renseigner votre nom"
    },
    'first-name': {
        label: "Prénom",
        'error-msg': "Merci de renseigner votre prénom",
        placeholder: "ex : Andrew Taylor",
        title: "Veuillez renseigner votre prénom"
    },
    siren: {
        label: "SIREN",
        'error-msg': "Merci de renseigner un SIREN valide",
        placeholder: "ex : 803473990",
        title: "Veuillez renseigner votre SIREN"
    },
    adeli: {
        label: "Numéro ADELI",
		'error-msg': "Merci de renseigner un numéro ADELI valide",
        placeholder: "ex : 350400037",
        title: "Veuillez renseigner votre numéro ADELI"
    },
	transmit: {
		label: "activer la télétransmission",
		title: "Télétransmission pour votre compte",
		'active-label': "télétransmission activée",
		'medsmart-actived': "Votre compte MedSmart est déjà activé, il n'est donc pas nécessaire de le réactiver.",
		'message-update-nip': "La dernière tentative de mise à jour de votre NIP avec MedSmart a échoué. Merci de vérifier votre RPPS ou votre ADELI."
	},
	rpps: {
		label: "Numéro RPPS",
		placeholder: "ex : 100190453281",
		title: "Veuillez renseigner votre numéro RPPS"
	},
	'facture-electronique': {
		pill: "Facturation électronique",
		help1: {
			text: "Dans le cadre de la {0}, certaines informations d'identification de votre entreprise sont nécessaires pour le {1}.",
			'strong-text1': "réforme de la facturation électronique",
			'strong-text2': "routage de vos factures électroniques"
		},
		help2: {
			text: "Le {0} et le {1} permettent d'identifier votre entreprise auprès de la {2} et des plateformes partenaires.",
			'strong-text1': "SIREN",
			'strong-text2': "code NAF / APE",
			'strong-text3': "DGFiP"
		},
		help3: {
			text: "Leur renseignement sera {0}",
			'strong-text1': "obligatoire à compter du 1er septembre 2026."
		},
		requirement: "Champs requis pour l'activation B2Brouter & DGFiP — obligatoire au 01/09/2026",
		'siren-help': "Identifiant principal de routage de vos factures B2B.",
		tva: {
			label: "Numéro de TVA intracommunautaire",
			placeholder: "ex : FR12345678901",
			title: "Veuillez renseigner votre numéro de TVA intracommunautaire",
			help: "Préfixé par FR. Auto-renseigné depuis votre SIREN si applicable."
		},
		naf: {
			label: "Code NAF / APE",
			placeholder: "ex : 8690F",
			title: "Veuillez renseigner votre code NAF / APE",
			help: "8690F – Activités de santé humaine non classées ailleurs (par défaut pour ostéopathes)."
		},
		'nom-societe': {
			label: "Nom de la société",
			placeholder: "ex : Cabinet Dupont SELARL",
			title: "Veuillez renseigner le nom de votre société"
		},
		'adresse-societe': {
			label: "Adresse société",
			title: "Veuillez renseigner l'adresse de votre société"
		},
		autofill: {
			label: "Récupérer depuis le SIREN",
			title: "Renseigner automatiquement le code NAF à partir de votre SIREN",
			success: "Code NAF récupéré à partir de votre SIREN.",
			error: "Impossible de récupérer les informations de votre entreprise. Vérifiez votre SIREN ou renseignez les champs manuellement."
		},
		infos: {
			text1: "Votre profil est incomplet. Merci de renseigner votre SIREN, votre code NAF/APE, le nom et l'adresse de votre société afin de pouvoir accepter la facturation électronique."
		},
		button1: {
			title: "Revenir sur mon choix",
			label: "revenir sur mon choix"
		},
		button2: {
			title: "Choisir ma Plateforme Agrée",
			label: "choisir ma Plateforme Agrée"
		},
		alert: {
			'no-choice': "Vous n'avez pas encore fait votre choix concernant votre Plateforme Agréée (PA). Choisissez B2Brouter pour activer votre facturation électronique.",
			refused: "Vous avez refusé de choisir B2Brouter comme Plateforme Agréée. Vous avez toujours la possibilité de revenir sur votre décision."
		},
		cancel: {
			alert: "Votre Plateforme Agréée (B2Brouter) est active. Vous pouvez à tout moment annuler votre PA ou les lignes activées pour vos remplaçants.",
			button: {
				title: "Annuler mon choix",
				label: "annuler mon choix"
			}
		}
	},
    'your-avatar': "Votre avatar",
    avatar: {
        title: "Gravatar",
        label: "Changer d'avatar"
    }
}
